module.exports = __webpack_public_path__ + "static/media/close-black.8c23c9c9.svg";